// Campus photo for /colleges/university-of-san-francisco: CC BY-SA 4.0, by Jallen8307, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3A2022.09.20_photowalk_UL_0945.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-san-francisco/; credited under the photo.
const photo = {
    "slug": "university-of-san-francisco",
    "alt": "Saint Ignatius Church and the University of San Francisco campus seen past flowering gardens on Lone Mountain",
    "src": "/colleges/university-of-san-francisco/campus-1600.webp",
    "srcSmall": "/colleges/university-of-san-francisco/campus-800.webp",
    "srcMid": "/colleges/university-of-san-francisco/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-san-francisco/og.jpg",
    "title": "2022.09.20 photowalk UL 0945",
    "author": "Jallen8307",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3A2022.09.20_photowalk_UL_0945.jpg",
    "read": "2026-10-02"
};

export default photo;
